// src/hooks/useReferenceData.ts
import { useEffect, useState } from 'react';
import { dedupedRequest } from '../utils/axios';  // axios instance with token refresh

export function useReferenceData() {
  const [clients, setClients] = useState([]);
  const [legalAreas, setLegalAreas] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    dedupedRequest({ method: 'GET', url: '/admin/clients' }, { useCache: true })
      .then(res => setClients(res.data))
      .catch(err => console.error('Failed to load clients:', err));
    dedupedRequest({ method: 'GET', url: '/admin/legal_areas' }, { useCache: true })
      .then(res => setLegalAreas(res.data))
      .catch(err => console.error('Failed to load legal_areas:', err));
    dedupedRequest({ method: 'GET', url: '/admin/clusters' }, { useCache: true })
      .then(res => setClusters(res.data))
      .catch(err => console.error('Failed to load clusters:', err));
    dedupedRequest({ method: 'GET', url: '/admin/admin_users' }, { useCache: true })
      .then(res => setUsers(res.data))
      .catch(err => console.error('Failed to load admin users:', err));
  }, []);

  return { clients, legalAreas, clusters, users };
}




